import { useContext, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import AdaptiveTable from "@components/AdaptiveTable";
import { getMinerErrors, IMinerErrors } from "@services/minerErrors";
import useTypedRequest from "@utils/hooks/useTypedRequest";
import { MinerContext } from "../../MinerContext";
import CloneSettings from "../CloneSettings/CloneSettings";
import StartMining from "../../../StartMining/StartMining";
import MinerDataFields from "../MinerDataFields/MinerDataFields";
import { Panel } from "@components/global/new/Panel/Panel";
import { ALGOS_E } from "@constants/Algos";
import { MINER_STATUSES_E } from "@constants/MinerStatuses";
import { MinerActions } from "../../minerReducer";
import { Button, Segmented } from "antd";
import { DeleteOutlined, WarningOutlined } from "@ant-design/icons";
import { Tabs } from "antd";
import PanelWithTable from "./PanelWithTable";
import MinerErrorsHistory from "./MinerErrorsHistory";
import MinerCommandHistory from "./MinerComandHistory";
import { IS_DEBUG } from "../../../../../../config";


function useMinerRowMoreControlControl() {
  const { miner, dispatchMiner } = useContext(MinerContext);
  const { request } = useTypedRequest(getMinerErrors);
  const [errors, setErrors] = useState<IMinerErrors[]>([]);

  useEffect(() => {
    let isMounted = true;

    async function loadErrors() {
      const response = await request(miner.id);

      if (!response || !isMounted) return;
      setErrors(response.Records);
      // setErrors([
      //   {
      //     "Id": 58061,
      //     "MinerId": 13119,
      //     "Code": "P:1",
      //     "Data": "{\"cause\":\"High temperature protection\",\"code\":\"P:1\",\"suggestion\":\"Check whether the environment temperature is normal, or check whether the gel on the hashboard is effective\"}",
      //     "Timestamp": 1784546881,
      //     "TimestampStr": "20.07.2026 11:28:01"
      //   }
      // ]);
    }

    loadErrors();

    return () => {
      isMounted = false;
    };
  }, [miner.id]);

  const onChangeStatus = (status: MINER_STATUSES_E) => {
    dispatchMiner({
      type: MinerActions.Status,
      payload: { state: status },
    });
  };

  return {
    errors,
    miner,
    onChangeStatus,
  };
}


function MinerRowMoreControl(): JSX.Element {

  const control = useMinerRowMoreControlControl();

  return (<div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
    <Panel theme="light" style={{ padding: 12 }}>
      <div
        style={{
          display: "flex",
          gap: 10,
          alignItems: "center",
        }}
      >
        {/*<MinerErrors />*/}
        <CloneSettings
          miner={control.miner.miner_id}
          currSettings={{
            notes: control.miner.admin_note || "",
            speed_drop: control.miner.speed_drop,
            miner_type: control.miner.profile,
            mining_persent: control.miner.proof,
            miner_plan: control.miner.plan,
            location: control.miner.location_raw,
            default_speed:
              control.miner.profile?.performance || 0,
            hash: control.miner.hash || ALGOS_E.SHA256,
            admin_setting: control.miner.admin_mining_setting,
            customer: {
              customer_uuid: control.miner.customer_uuid || "",
              customer_name: control.miner.customer_name || "",
              customer_email: control.miner.customer_email || "",
              customer_id: control.miner.customer_id || "",
            },
          }}
        />
      </div>
      <StartMining
        minerID={control.miner.id}
        minerName={control.miner.miner_id}
        status={control.miner.status}
        onChangeStatus={control.onChangeStatus}
      />
      <MinerDataFields />
    </Panel>
    <MinerErrorsHistory minerId={control.miner.id} />
    <MinerCommandHistory minerId={control.miner.id} />
  </div>
  );
}


export default MinerRowMoreControl;
